import { cap } from '../../../State'
import { translations } from '../../../translations'
import { Icon } from './Icons'

const language = cap.language.state || 'IT'
const t = translations[language]

/**
 * Barra fissa in cima al form quando Nora sta elaborando il messaggio
 * @returns {JSX.Element} Banner di elaborazione in corso
 */
export const ProcessingBar = () => (
  <div className="gf-processing-bar" role="status" aria-live="polite">
    <span className="gf-processing-bar__spinner" aria-hidden="true" />
    <div className="gf-processing-bar__content">
      <span className="gf-processing-bar__title">
        <Icon name="sparkles" size={14} />
        {t.elaborazioneMessaggioInCorso}
      </span>
      <span className="gf-processing-bar__detail">{t.elaborazioneMessaggioInCorsoDetails}</span>
    </div>
  </div>
)
